<template>
  <v-card tile>
    <v-card-title class="grey lighten-2">
      Ta bort Banner
    </v-card-title>
    <v-card-text class="pt-8">
      <p>Är du säker på att du vill ta bort banner: {{ this.model.title }}</p>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer />
      <v-btn :disabled="pending" rounded @click="closeModal">Stäng</v-btn>
      <v-btn
        rounded
        type="submit"
        color="error"
        :loading="pending"
        @click="onConfirm"
      >
        Ta bort
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import DELETE_TIB_BANNER from '../graphql/removeTibBanner.graphql'
import { get } from 'vuex-pathify'

export default {
  name: 'TibBannerDeleteModal',

  data: () => ({
    valid: true,
    pending: false
  }),

  computed: {
    model: get('tibBanner/model')
  },

  methods: {
    async onConfirm() {
      this.pending = true
      await this.$apollo.mutate({
        mutation: DELETE_TIB_BANNER,
        variables: {
          payload: {
            uuid: this.model.uuid
          }
        }
      })
      await this.$store.dispatch(
        'tibBanner/fetch',
        this.$store.get('tibBanner/filter@date')
      )
      this.pending = false
      this.closeModal()
    },

    closeModal() {
      this.$emit('close')
      this.$store.dispatch('tibBanner/resetModel')
    }
  }
}
</script>
